import {Component, OnDestroy, OnInit} from '@angular/core';
import {LoaderService} from '@app/services/loader.service';
import {Router} from '@angular/router';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {getError, getLoggedInUser, getToken, IAuthenticationState, LogoutUser, TokenLogin} from '@app/stores';
import {select, Store} from '@ngrx/store';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';

@Component({
  selector: 'app-token-refresh',
  templateUrl: './token-refresh.component.html',
  styleUrls: ['./token-refresh.component.css']
})
export class TokenRefreshComponent implements OnInit, OnDestroy {

  private loginToken;
  unsubscriber = new Subject();
  public refreshTokenClick = false;

  constructor(
    private loaderService: LoaderService,
    private router: Router,
    private model: NgbActiveModal,
    private authenticationStore: Store<IAuthenticationState>
  ) {
    this.authenticationStore.pipe(select(getToken))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(token => {
        if (token) {
          this.loginToken = token;
        }
      });

    this.authenticationStore.pipe(select(getLoggedInUser))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(user => {
        if (user) {
          if (this.refreshTokenClick) {
            this.refreshTokenClick = false;
            this.model.close();
          }
        }
      });

    this.authenticationStore.pipe(select(getError))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(error => {
        if (error) {
          this.loginClick();
        }
      });
  }

  ngOnInit(): void {
    this.loaderService.logoutSubject.next(false);
  }

  refreshToken() {
    localStorage.removeItem('loginInTime');
    this.refreshTokenClick = true;
    this.authenticationStore.dispatch(TokenLogin({token: this.loginToken}));
  }

  loginClick() {
    localStorage.removeItem('reportPassword');
    localStorage.removeItem('currentUser');
    localStorage.removeItem('influencerSearchValue');
    localStorage.removeItem('loginInTime');
    localStorage.removeItem('projectFilterList');
    this.loaderService.unsubscribe();
    this.authenticationStore.dispatch(LogoutUser());
    this.router.navigate(['/login']);
    this.model.close();
  }

  ngOnDestroy() {
    this.unsubscriber.next(undefined);
    this.unsubscriber.complete();
  }

}
